import { render, staticRenderFns } from "./BannerDiverseTeams.vue?vue&type=template&id=913a1062&scoped=true&"
import script from "./BannerDiverseTeams.vue?vue&type=script&lang=js&"
export * from "./BannerDiverseTeams.vue?vue&type=script&lang=js&"
import style0 from "./BannerDiverseTeams.vue?vue&type=style&index=0&id=913a1062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a1062",
  null
  
)

export default component.exports